import React from 'react';
import { Badge, ButtonField } from '@wk/components-v3-react16';
import styles from './ClearFiltersButton.module.css';
import { useClearFilters } from '../useClearFilters';

const ClearFiltersButton = () => {
  const { activeFilterCount, handleClearFilters, hasActiveFilters } =
    useClearFilters();

  if (!hasActiveFilters) {
    return null;
  }

  return (
    <ButtonField type="text">
      <button onClick={handleClearFilters}>
        Clear filters
        <Badge label={`${activeFilterCount}`} flowClass={styles.bgBlue} />
      </button>
    </ButtonField>
  );
};

export default ClearFiltersButton;
